import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  applyThemeToDocument,
  getStoredTheme,
} from "../salon-admin/utils/theme";

import "../naturals/executive/assets/fonts/local-fonts.css";
import "../naturals/executive/index.css";

export default function NyafazPortalFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
    const sync = () => applyThemeToDocument(getStoredTheme());
    window.addEventListener("storage", sync);
    window.addEventListener("themechange", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("themechange", sync);
    };
  }, []);

  return <Outlet />;
}
